/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { darken, lighten } from '@material-ui/core/styles';
import {
  ChatEventType,
  EventEntity,
  nonActionMsgTypes,
} from 'app/core/api/repairer/api-repairer.types';
import {
  currentUserRole,
  mapUserRoleFromEventType,
} from 'app/core/api/user/user-utils';
// import { getButtonText } from 'app/shared/pages/Chat/chat-msg-templates';
import {
  EMPTY_MESSAGE,
  InitiateMsg,
} from 'app/shared/pages/Chat/chat-utils';
import styledConsts from 'app/styles/styledConsts';
import styledFuncs from 'app/styles/styledFuncs';
import styledMixins from 'app/styles/styledMixins';
import { isInArray } from 'app/tools/general.types';
import { sentenceCase } from 'app/tools/utils';
import React from 'react';
import styled, { css } from 'styled-components/macro';
import AppImage from '../app-image/AppImage';
// import Button from '../button/Button';
import Icon from '../icon/Icon';
import IconLib, { IWRepairerSvg, RobotSvg } from '../icon/icon-lib';

const THIS_USER = 'this-user';
const OTHER_USER = 'other-user';

const UserIcon = styled(Icon).attrs({
  size: 18,
})`
  margin: 0 ${styledFuncs.pad(0.5)};
`;

const MsgBoxTitle = styled.div``;
const MsgTextBox = styled.div<{ $noPad?: boolean }>`
  ${styledMixins.roundCorners};
  display: flex;
  flex-direction: column;
  overflow: hidden;
  > * {
    margin: 0;
    padding: ${styledFuncs.pad(0.5)} ${styledFuncs.pad()};
    ${p =>
      p.$noPad &&
      css`
        padding: 0;
      `}
    word-wrap: break-word;
  }
  > ${MsgBoxTitle} {
    align-self: stretch;
    padding: 2px ${styledFuncs.pad()};
  }
`;

type MsgRowOpts = {
  $isMsgSentBySelf: boolean;
  $isBotMsg: boolean;
};
const MsgRow = styled.div<MsgRowOpts>`
  display: flex;
  align-items: center;
  flex-direction: ${p =>
    p.$isBotMsg
      ? 'column'
      : p.$isMsgSentBySelf
      ? 'row-reverse'
      : 'row'};
  margin: ${styledFuncs.pad(2)} 0 0;
  &:nth-last-child(2) {
    margin-bottom: ${styledFuncs.pad()};
  }

  &.${THIS_USER} + &.${THIS_USER}, &.${OTHER_USER} + &.${OTHER_USER} {
    margin-top: ${styledFuncs.pad()};
  }

  ${UserIcon} {
    color: ${p =>
      p.$isMsgSentBySelf ? styledConsts.cPrimary : '#999'};
  }

  ${MsgBoxTitle} {
    ${styledMixins.roundCorners}
    ${styledMixins.noRadiusBottom}
    font-style: italic;
    text-transform: uppercase;
    font-size: ${styledFuncs.pxToRem(12)};
    background-color: ${p =>
      p.$isBotMsg
        ? '#ffffff'
        : p.$isMsgSentBySelf
        ? lighten(styledConsts.cPrimary(p), 0.3)
        : '#dbdbdb'};
    color: ${p =>
      p.$isBotMsg
        ? '#7A7A7A'
        : p.$isMsgSentBySelf
        ? darken(styledConsts.cPrimary(p), 0.4)
        : '#626262'};
    border: 1px solid;
    border-color: ${p =>
      p.$isMsgSentBySelf
        ? darken(styledConsts.cPrimary(p), 0.3)
        : '#b1b0b0'};
    box-shadow: ${p =>
      p.$isBotMsg ? '0px 3px 10px rgba(0, 0, 0, 0.161)' : 'none'};
  }
  ${MsgTextBox} {
    background-color: ${div =>
      div.$isBotMsg
        ? '#fff'
        : div.$isMsgSentBySelf
        ? styledConsts.cPrimary
        : '#ededed'};
    div {
      color: ${div =>
        div.$isBotMsg
          ? '#7A7A7A'
          : div.$isMsgSentBySelf
          ? '#fff'
          : styledConsts.cText};
    }
    border-color: ${div =>
      div.$isMsgSentBySelf ? '#99ea99' : '#bdbdbd'};
    box-shadow: ${div =>
      div.$isBotMsg ? '0px 3px 10px rgba(0, 0, 0, 0.161)' : 'none'};
    text-align: ${div => (div.$isBotMsg ? 'center' : 'left')};
  }
  > span {
    display: flex;
    flex-direction: column;
    max-width: 60%;
    ul {
      list-style: none;
      padding: 0;
      margin: 0;
    }
  }
`;
// const ActionButton = styled(Button)`
//   margin-top: ${styledFuncs.pad(0.8)};
//   min-height: 40px;
//   font-size: 17px;
//   padding-top: 0;
//   padding-bottom: 0;
//   width: 100%;
// `;
// const StyledMedia = styled.img`
//   max-width: 60%;
//   margin: 0;
//   padding: 0;
//   margin: ${styledFuncs.pad(2)} 0 0;
//   ${styledMixins.roundCorners};
// `;

export type Props = {
  msg: EventEntity;
  initiateMsg: InitiateMsg;
  className?: string;
  currencySymbol: string;
  OpenQuote?: (evt: EventEntity) => unknown;
};
export default function MsgItem({
  msg,
  initiateMsg,
  className,
  OpenQuote,
}: Props): JSX.Element {
  const msgSender = mapUserRoleFromEventType[msg.eventType];
  const isMsgSentBySelf = currentUserRole === msgSender;
  const isBotMsg = msg.eventType === ChatEventType.BOT_MESSAGE;
  // only set messageTitle if eventType is an action message type
  const messageTitle = !isInArray(msg.eventType, nonActionMsgTypes)
    ? sentenceCase(msg.eventType)
    : undefined;

  // const Content = (): JSX.Element =>
  //   !msg.isImage ? (
  //     <MsgBoxContainer>
  //       <p>{msg.content}</p>
  //     </MsgBoxContainer>
  //   ) : (
  //     <StyledMedia src={msg.imgUrl} />
  //   );
  return (
    <MsgRow
      $isMsgSentBySelf={isMsgSentBySelf}
      $isBotMsg={isBotMsg}
      className={[
        isMsgSentBySelf ? THIS_USER : OTHER_USER,
        className,
      ].join(' ')}
    >
      {isBotMsg && (
        <div style={{ marginBottom: '1px' }}>
          <RobotSvg />
        </div>
      )}
      {!isBotMsg &&
        (msgSender === 'user' ? (
          <UserIcon icon={IconLib.USER} />
        ) : (
          <IWRepairerSvg
            style={{
              width: '12.19px',
              marginLeft: '10px',
              marginRight: '10px',
            }}
          />
        ))}
      {/* <MsgTextBox>
        <p>{msg.displayText}</p>
      </MsgTextBox> */}
      <span>
        <MsgTextBox $noPad={!!msg.imageUrl}>
          {/* {messageTitle && <MsgBoxTitle>{messageTitle}</MsgBoxTitle>} */}
          {msg.imageUrl ? (
            <AppImage
              height="150px"
              noPad
              src={msg.imageUrl}
              className="cursor-pointer touch-callout"
              css={`
                img {
                  object-fit: cover;
                }
              `}
              alt="image sent in chat"
            />
          ) : (
            <div
              onClick={() =>
                msg.eventType !== ChatEventType.REPAIRER_MESSAGE &&
                msg.eventType !== ChatEventType.CONSUMER_MESSAGE &&
                msg.eventType !== ChatEventType.BOT_MESSAGE &&
                OpenQuote !== undefined &&
                OpenQuote(msg)
              }
            >
              {msg.displayText !== EMPTY_MESSAGE && msg.displayText}
              {msg.eventType !== ChatEventType.REPAIRER_MESSAGE &&
                msg.eventType !== ChatEventType.CONSUMER_MESSAGE &&
                msg.eventType !== ChatEventType.BOT_MESSAGE &&
                OpenQuote !== undefined && (
                  <div
                    style={{
                      textAlign: 'center',
                      fontSize: '10px',
                      paddingLeft: '8px',
                    }}
                    /* onClick={() => OpenQuote(msg.eventType)} */
                  >
                    {/* {msg.eventType ===
                    ChatEventType.DIAGNOSIS_QUOTE ? (
                      <>(tap for more info)</>
                    ) : (
                      <>(tap to track repair status)</>
                    )} */}
                    {(msg.eventType ===
                      ChatEventType.DIAGNOSIS_QUOTE ||
                      msg.eventType === ChatEventType.REPAIR_QUOTE ||
                      msg.eventType ===
                        ChatEventType.DIAGNOSIS_QUOTE_ACCEPT ||
                      msg.eventType ===
                        ChatEventType.REPAIR_QUOTE_ACCEPT ||
                      msg.eventType ===
                        ChatEventType.DIAGNOSIS_QUOTE_DECLINE ||
                      msg.eventType ===
                        ChatEventType.REPAIR_QUOTE_DECLINE) && (
                      <>(tap for more info)</>
                    )}
                    {msg.eventType ===
                      ChatEventType.WARRANTY_CLAIM && (
                      <>(tap to select collection date)</>
                    )}
                  </div>
                )}
            </div>
          )}
        </MsgTextBox>
      </span>
    </MsgRow>
  );
}
